import instituicaoFinanceiraList from '../instituicaoFinanceiraList'



const corretoraValoresList = () => {

    return instituicaoFinanceiraList.filter(linhaInstituicaoFinanceiraList => linhaInstituicaoFinanceiraList.corretoraValores === 'S')
}

export default corretoraValoresList